import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SharedService } from 'src/app/services/shared.service';
import { Location } from '@angular/common';
import { MediaLibraryHttpService } from 'src/app/http/media-library-http.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MediaModalComponent } from 'src/app/shared/modals/media-modal/media-modal.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { EventsService } from 'src/app/services/events.service';
import { BranchHttpService } from 'src/app/http/branch-http.service';

@UntilDestroy()
@Component({
    selector: 'app-branch-new',
    templateUrl: './branch-new.component.html',
    styles: [],
})
export class BranchNewComponent implements OnInit, OnDestroy {
    constructor(
        private fb: FormBuilder,
        private branchHttpService: BranchHttpService,
        private sharedService: SharedService,
        private router: Router,
        public location: Location,
        private mediaLibraryHttpService: MediaLibraryHttpService,
        private modalService: NgbModal,
        private eventsService: EventsService
    ) {}

    newBranchForm = this.fb.group(
        {
            branchName: [null, Validators.required],
            address: [null, Validators.required],
            phone: [null, Validators.required],
            mapLocation: [null],
            assetId: [null],
            isPublished: [false],
        },
        { updateOn: 'submit' }
    );

    formBusy: boolean;

    selectAsset: any;

    ngOnInit(): void {
        this.eventsSub();
    }

    eventsSub() {
        this.eventsService.trigger.pipe(untilDestroyed(this)).subscribe((data) => {
            if (data.name === 'selectedAsset') {
                const selected = data.value.slice(-1).pop();
                if (selected) {
                    this.selectAsset = selected;
                    this.newBranchForm.controls['assetId'].setValue(selected.assetId);
                }
            }
        });
    }

    onSubmit() {
        this.newBranchForm.markAsTouched();
        if (this.newBranchForm.valid) {
            this.formBusy = true;
            this.branchHttpService.newBranch(this.newBranchForm.value).subscribe(
                () => {
                    this.router.navigateByUrl('branch-list', {
                        state: { hasState: true, type: 'success', message: 'Branch Created successfully' },
                    });
                },
                () => {
                    this.formBusy = false;
                    this.newBranchForm.setErrors({ exists: true });
                }
            );
        }
    }

    openMedia() {
        this.mediaLibraryHttpService.getAllFolders().subscribe((folders) => {
            let media = this.modalService.open(MediaModalComponent, { size: 'xl', windowClass: 'media-library' });
            media.componentInstance.folders = folders;
        });
    }

    clearImages() {
        this.selectAsset = null;
        this.newBranchForm.controls['assetId'].setValue(null);
    }

    ngOnDestroy(): void {
        this.eventsService.trigger.next({ name: null, value: null });
    }
}
